<template>
    <div class="flex w-full justify-end my-5">
        <button type="button" :disabled="!checked_in.self" @click="addLine"
                class="block mr-2 bg-white hover:bg-gray-100 text-gray-800 font-semibold px-4 border border-gray-400 rounded shadow">
            <i class="fa fa-plus-square"></i> <span class="hidden sm:inline">Nova linha</span>
        </button>
        <button type="button" :disabled="!checked_in.self" @click="removeBlankLines"
                class="block bg-white hover:bg-gray-100 text-gray-800 font-semibold px-4 border border-gray-400 rounded shadow">
            <i class="fa fa-minus-square"></i> <span class="hidden sm:inline">Remover linhas em branco</span>
        </button>
    </div>
</template>

<script>

export default {
    props: ['checked_in'],
    emits: ['addLine', 'removeBlankLines'],
    methods: {
        addLine: function() {
            this.$emit('addLine')
        },
        removeBlankLines: function() {
            this.$emit('removeBlankLines')
        }
    }
}
</script>
